/**
 * Verifica si hay cuentas de Instagram conectadas para una página de Facebook específica
 * @param {Object} integrations - Objeto de integraciones del usuario
 * @param {string} integrationID - ID de la integración de Meta
 * @param {string} pageID - ID de la página de Facebook
 * @returns {boolean} - true si hay cuentas de Instagram conectadas, false en caso contrario
 */
export const hasInstagramAccountsConnected = (
  integrations,
  integrationID,
  pageID
) => {
  if (!integrations || !integrationID || !pageID) return false;

  const metaIntegrations = integrations?.facebook;
  if (!metaIntegrations) return false;

  const integration = metaIntegrations[integrationID];
  if (!integration) return false;

  const instagramAccounts =
    integration?.pages?.[pageID]?.instagramAccounts || {};
  const instagramAccountsKeys = Object.keys(instagramAccounts);

  return instagramAccountsKeys.length > 0;
};
